import { useToast } from "../../hooks/use-toast"
import {
    Toast,
    ToastClose,
    ToastDescription,
    ToastTitle,
} from "./toast"

export function Toaster() {
    const { toasts, dismiss } = useToast()

    return (
        <div className="fixed top-0 z-[200] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]">
            {toasts.map(({ id, title, description, action, ...props }) => {
                return (
                    <Toast key={id} {...props}>
                        <div className="grid gap-1">
                            {title && <ToastTitle>{title}</ToastTitle>}
                            {description && <ToastDescription>{description}</ToastDescription>}
                        </div>

                        {action}

                        <ToastClose onClick={() => dismiss(id)} />
                    </Toast>
                )
            })}
        </div>
    )
}
